enum ConditionType {
	Default = "default",
	Equality = "equality",
	InInterval = "in_interval",
}

export default ConditionType;
